module.exports = __webpack_public_path__ + "img/rapido-blue.04b38ae.svg";